<template>
    <div v-if="value">
        <input-text
            label="Rubrik"
            required
            v-model:content="value.title"
        />
        <div
            class="grid gap-5 mb-3"
            :class="layout === 'half' ? 'grid-cols-1' : 'grid-cols-1 lg:grid-cols-2'"
        >
            <input-media-bank-entry
                type="image"
                label="Välj en bild från mediabiblioteket"
                required
                v-model:content="value.media_bank_entry_id"
            />
            <media-bank-entries-display v-if="value.media_bank_entry_id" :data-url="route('mediaBank.entries.show', value.media_bank_entry_id)" />
        </div>
        <div v-for="(link, idx) in value.links" :key="idx" class="flex items-center w-full mb-2">
            <input-text maxlength="255" :label="`Länktext ${idx + 1}`" class="w-full mr-2" required v-model:content="link.text" />
            <input-text maxlength="255" inputtype="url" :label="`Länk ${idx + 1}`" class="w-full mr-2" v-model:content="link.href" />
            <button v-if="value.links.length > 0" type="button" @click="deleteLine(idx)">
                <TrashIcon class="w-5 h-5 text-myflowRed" aria-hidden="true" />
            </button>
        </div>
        <button type="button" class="mb-3 myflow-basic-button" @click="addLine">Lägg till knapp</button>
    </div>
    <mf-spinner-medium v-else class="w-16 h-8"></mf-spinner-medium>
</template>
<script>
import {
    TrashIcon
} from '@heroicons/vue/outline';

export default {
    components: {
        TrashIcon
    },
    props: {
        modelValue: {},
        layout: {
            type: String,
            default: 'full'
        }
    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            value: null
        };
    },
    async mounted() {
        this.captureModelValue();
    },
    watch: {
        modelValue() {
            if (JSON.stringify(this.value) === JSON.stringify(this.modelValue)) { return; }
            this.captureModelValue();
        },
        value: {
            handler() {
                this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
            },
            deep: true
        }
    },
    methods: {
        captureModelValue() {
            const value = this.modelValue ? JSON.parse(JSON.stringify(this.modelValue)) : {};
            if (!value.title) { value.title = null; }
            if (!value.media_bank_entry_id) { value.media_bank_entry_id = null; }
            if (!value.links) { value.links = [{text: null, href: null}]; }
            this.value = value;
        },
        addLine() {
            this.value.links.push({text: null, href: null});
        },
        deleteLine(idx) {
            this.value.links.splice(idx, 1);
        }
    },
}
</script>
